export const fallbackBusinesses = [
  {
    id: "demo-business-1",
    name: "Torqo Центр",
    category: "shynomontazh",
    address: "просп. Дмитра Яворницького, 32",
    latitude: 48.4647,
    longitude: 35.0462,
    phone: "+380561112233",
    description: "Демо-сервіс для базового перегляду Torqo, якщо Supabase ще порожній.",
    rating: 4.8,
    is_verified: true,
    is_active: true,
    services: [
      { id: "demo-service-1", name: "Сезонна заміна шин", price_from: 950, car_type: "car", wheel_size: "R16", duration_minutes: 45 },
      { id: "demo-service-2", name: "Балансування", price_from: 450, car_type: "car", wheel_size: "R16", duration_minutes: 30 },
    ],
  },
  {
    id: "demo-business-2",
    name: "ШиноСервіс Перемога",
    category: "shynomontazh",
    address: "Набережна Перемоги, 86",
    latitude: 48.452,
    longitude: 35.071,
    phone: "+380562223344",
    description: "Демо-картка шиномонтажу з цінами, рейтингом і швидким записом.",
    rating: 4.7,
    is_verified: false,
    is_active: true,
    services: [
      { id: "demo-service-3", name: "Ремонт проколу", price_from: 350, car_type: "car", wheel_size: "R15", duration_minutes: 25 },
    ],
  },
];

export const fallbackReviews = [
  { id: "demo-review-1", business_id: "demo-business-1", rating: 5, text: "Швидко і зручно.", created_at: "2026-06-25T09:00:00.000Z" },
];
